import AddToCartFormik from '@jetshop/core/components/Mutation/AddToCartFormik';
import { useNotification } from '@jetshop/core/components/Notifications';
import { useCart } from '@jetshop/core/components/Query/CartProvider';
import t from '@jetshop/intl';
import { PreOrderDateSelector } from '@jetshop/ui/PreOrderDateSelector';
import { useStockStatus } from '@jetshop/ui/Stock/StockStatusContainer';
import { Form } from 'formik';
import { css, cx } from 'linaria';
import { styled } from 'linaria/react';
import React, { useEffect, useState } from 'react';
import addToCartMutation from '../../Cart/addToCart.gql';
import CartQuery from '../../Cart/CartQuery.gql';
import InputWithLabel from '../../Forms/Input';
import { theme } from '../../Theme';
import Button from '../../ui/Button';
import { ConfigurationSelector } from '../ConfigurationSelector';
import { IncludedInPackages } from '../PackageProduct/IncludedInPackages';
import NotifyWhenBack from '../StockStatus/NotifyWhenBack';
import { useProductValidationMessage } from '../useProductValidationMessage';
import { dropdownStyles, VariantSelector } from '../VariantSelector';
import ProductToastWrapper from './ProductToast';
import { FamilyMembers } from '../FamilyMembers';

const StyledForm = styled(Form)`
  display: flex;
  width: 100%;
  flex-direction: column;
  margin-bottom: 9px;
  ${theme.below.lg} {
    align-items: center;
  }
`;

const QuantityAddToCartWrapper = styled('div')`
  display: flex;
  width: 100%;
  align-items: flex-end;
`;

const preOrderDateSelectorStyles = css`
  && {
    [data-flight-dropdown-items] {
      width: 100%;
      height: 200px;
      overflow: scroll;
    }
  }
`;

const BuyButtonRow = styled('div')`
  display: flex;
  justify-content: space-evenly;
  width: 100%;

  button {
    background: black;
    height: 40px;
    font-style: normal;
    font-weight: bold;
    font-size: 12px;
    line-height: 12px;
    text-align: center;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    color: #ffffff;

    &:active,
    &:focus {
      outline: none;
    }
  }

  ${theme.below.lg} {
    justify-content: flex-start;
    flex-direction: column;
    button {
      margin-bottom: 5px;
      margin-right: 0px;
    }
  }
`;

// const GiftCardSelectWrapper = styled('div')`
//   margin-top: 10px;
//   margin-bottom: 20px;

//   h4 {
//     font-size: 14px;
//   }
//   p {
//     margin-top: 6px;
//     font-size: 14px;
//     line-height: 140%;
//   }

//   .giftcard-buttons {
//     display: flex;
//     margin-top: 20px;
//     button {
//       height: 40px;
//       margin-right: 10px;
//       font-size: 14px;
//       color: #333;
//       background-color: #f7f7f7;
//       font-weight: 500;

//       &.selected {
//         background-color: #333;
//         color: #fff;
//       }
//     }
//   }

//   .digital-form {
//     h4 {
//       margin-top: 20px;
//     }
//     form {
//       display: flex;
//       flex-direction: column;
//     }

//     input {
//       height: 40px;
//       border: 1px solid #dedede;
//       background-color: #fcfcfc;
//     }

//     label {
//       margin-top: 10px;
//       font-size: 12px;
//       margin-bottom: 2px;
//     }
//   }
// `;

// const GiftCardSelect = () => {
//   const [selected, setSelected] = useState('digital');
//   return (
//     <GiftCardSelectWrapper>
//       <h4>Type av gavekort</h4>
//       <p>
//         Velg hvordan du vil at vi skal levere gavekortet ditt. Enten som et
//         fysisk gavekort eller digitalt til din e-post eller mobiltelefon.
//       </p>
//       <div className="giftcard-buttons">
//         <Button
//           className={selected === 'physical' && 'selected'}
//           onClick={() => setSelected('physical')}
//         >
//           Fysiskt gavekort
//         </Button>
//         <Button
//           className={selected === 'digital' && 'selected'}
//           onClick={() => setSelected('digital')}
//         >
//           Gavekort (E-MAIL)
//         </Button>
//         <Button
//           className={selected === 'digital' && 'selected'}
//           onClick={() => setSelected('digital')}
//         >
//           Gavekort (SMS)
//         </Button>
//       </div>
//       {/* {selected === 'digital' && (
//         <div className="digital-form">
//           <h4>Velg leverering via e-post eller SMS</h4>
//           <form>
//             <label>E-post</label>
//             <input />
//             <label>SMS</label>
//             <input />
//           </form>
//         </div>
//       )} */}
//     </GiftCardSelectWrapper>
//   );
// };

function GiftCardAddToCartForm({
  product,
  variant,
  getMissingOptions,
  variantHandler
}) {
  const stockStatus = useStockStatus(variant || product);
  const outOfStockNotify = stockStatus.status === 'notifyWhenBack';
  // const outOfStockNotify = stockStatus.status === 'outOfStock';
  const { validation: variantValidation, missingOptions } = variantHandler;
  const { hasVariants } = product;
  const { validationMessage, enableValidation } = useProductValidationMessage({
    missingOptions,
    variantValidation,
    hasVariants,
    stockStatus
  });
  const [trigger, dismiss] = useNotification();
  const { cart } = useCart(CartQuery);
  const [toCheckout, setToCheckout] = useState(false);

  console.log('gitfcard variatn', variant);
  console.log('giftcard product', product);

  const onAddToCartInit = ({
    product,
    selectedVariation,
    mutationId,
    quantity,
    price
  }) => {
    if (!toCheckout) {
      console.log('variant init', selectedVariation);
      console.log('price init', price);
      console.log('quantity init', quantity);
      console.log('mutationId init', mutationId);
      console.log('product init', product);
      trigger(
        <ProductToastWrapper
          selectedVariation={selectedVariation}
          product={product}
          quantity={quantity}
          price={price}
        />,
        {
          id: mutationId,
          type: 'add-to-cart'
        }
      );
    }
  };

  const onAddToCartSuccess = () => {};

  const onAddToCartError = () => {
    return ({ variant, mutationId, quantity, price, error }) => {
      dismiss(mutationId);

      trigger(
        <ProductToastWrapper
          selectedVariation={variant}
          product={product}
          quantity={quantity}
          price={price}
          error={error}
        />,
        {
          type: 'add-to-cart'
        }
      );
    };
  };

  useEffect(() => {
    if (toCheckout && cart?.externalCheckoutUrl) {
      window.location = cart?.externalCheckoutUrl;
    }
  }, [cart, toCheckout]);

  //zizr
  const colorType = product?.customFields?.filter(
    customField => customField?.key === 'farge'
  )[0]?.stringValue;
  const zizrId = product?.articleNumber + '_' + colorType?.toLowerCase();

  const colorVariants = product?.customFields?.find(
    ({ key }) => key === 'variants'
  )?.listValues;

  // const validation = validateSelection(value, option);

  console.log('val', validationMessage);

  return (
    <AddToCartFormik
      onAddToCartInit={onAddToCartInit}
      onAddToCartError={onAddToCartError}
      onAddToCartSuccess={onAddToCartSuccess}
      cartQuery={CartQuery}
      cartMutation={addToCartMutation}
      product={product}
      variant={variant}
      getMissingOptions={getMissingOptions}
    >
      {() => {
        return (
          <>
            {colorVariants?.length > 0 && (
              <FamilyMembers
                giftCard={true}
                articleNumbers={colorVariants}
                title={'Farge'}
                current={product}
                customFieldKey={'color'}
                variant={variant}
              />
            )}
            {product.hasVariants && (
              <VariantSelector
                product={product}
                variantHandler={variantHandler}
                showValidation={!!validationMessage}
                isDropdown={true}
              />
            )}
            {zizrId && (
              <div
                id="zizr"
                data-retailer-identifier="ferner-jacobsen"
                data-model-style-id={zizrId}
              ></div>
            )}
            {product.hasConfigurations && (
              <ConfigurationSelector product={product} />
            )}
            <PreOrderDateSelector
              className={cx(dropdownStyles, preOrderDateSelectorStyles)}
              product={product}
            />
            <IncludedInPackages packages={product.inPackages} />
            <StyledForm>
              {product.customerComments &&
                product.customerComments.map(comment => (
                  <InputWithLabel
                    wrapperClassName="customer-comment-input-wrapper"
                    className="customer-comment-input"
                    data-testid={`${comment.name}-input`}
                    id={`comments['${comment.name}']`}
                    name={`comments['${comment.name}']`}
                    label={comment.name}
                    key={comment.name}
                  />
                ))}
              {!outOfStockNotify && (
                <QuantityAddToCartWrapper>
                  <BuyButtonRow>
                    <Button
                      data-testid="add-to-cart"
                      type="submit"
                      disabled={!(variantValidation === 'valid')}
                      onClick={() => {
                        setToCheckout(false);
                        enableValidation();
                      }}
                      style={{
                        opacity: variantValidation === 'incomplete' ? 0.5 : 1,
                        width: '100%'
                      }}
                    >
                      {validationMessage ? validationMessage : t('Add to cart')}
                    </Button>
                  </BuyButtonRow>
                </QuantityAddToCartWrapper>
              )}
              {outOfStockNotify && (
                <NotifyWhenBack
                  articleNumber={(variant || product).articleNumber}
                />
              )}
            </StyledForm>
          </>
        );
      }}
    </AddToCartFormik>
  );
}

export default GiftCardAddToCartForm;
